import { IAnnotationTag, IBaseTrustTime } from '@patsnap/synapse_common_interface'
import { IBaseDiseaseInfo, IBaseDrugInfo } from '@pharmsnap/shared/types'
import { decrypt, decryptNum } from '@pharmsnap/shared/utils'
import { IBaseTargetInfo } from './../../../types/base'

/**
 * 不同类型新闻标签的解密配置
 */
const decryptConfig: Record<
  'custom' | 'organization' | 'target' | 'drug' | 'disease' | 'org_master_entity',
  (tag: any, xCorrelationId: string, fontClassName: string) => void
> = {
  custom: decryptName,
  organization: decryptOrgName,
  org_master_entity: decryptName,
  target: decryptTargetName,
  drug: decryptDrugName,
  disease: decryptDiseaseName,
}

function decryptName(item: { name_cn?: string; name_en?: string; fontClassName?: string }, xCorrelationId: string, fontClassName: string) {
  if (item.name_cn) {
    item.name_cn = decrypt(item.name_cn, xCorrelationId)
  }
  if (item.name_en) {
    item.name_en = decrypt(item.name_en, xCorrelationId)
  }
  item.fontClassName = fontClassName
}

function decryptOrgName(
  org: { name_cn?: string; name_en?: string; display_name_cn?: string; display_name_en?: string; fontClassName?: string },
  xCorrelationId: string,
  fontClassName: string
) {
  if (org.display_name_cn) {
    org.display_name_cn = decrypt(org.display_name_cn, xCorrelationId)
  }
  if (org.display_name_en) {
    org.display_name_en = decrypt(org.display_name_en, xCorrelationId)
  }
  decryptName(org, xCorrelationId, fontClassName)
}

function decryptDrugName(drug: IBaseDrugInfo, xCorrelationId: string, fontClassName: string) {
  drug.fontClassName = fontClassName
}

function decryptDiseaseName(disease: IBaseDiseaseInfo, xCorrelationId: string, fontClassName: string) {
  disease.fontClassName = fontClassName
}

function decryptTargetName(data: IBaseTargetInfo, xCorrelationId: string, fontClassName: string) {
  if (data.display_name_cn) {
    data.display_name_cn = decrypt(data.display_name_cn, xCorrelationId)
  }
  if (data.display_name_en) {
    data.display_name_en = decrypt(data.display_name_en, xCorrelationId)
  }
  data.fontClassName = fontClassName
}

/**
 * 新闻标签解密
 * @param tag
 * @param xCorrelationId
 * @param fontClassName
 */
export function decryptNewsTag(tag: IAnnotationTag, xCorrelationId: string, fontClassName: string) {
  if ('normalized_id_view' in tag) {
    const func = decryptConfig[tag.type]
    func && func(tag.normalized_id_view, xCorrelationId, fontClassName)
  }
}

/**
 * 新闻时间解密
 * @param item
 * @param xCorrelationId
 */
export function decryptNewsDate(item: { dmp_post_time?: IBaseTrustTime; post_time?: IBaseTrustTime }, xCorrelationId: string) {
  if (item.dmp_post_time) {
    item.dmp_post_time.time_ts = decryptNum(item.dmp_post_time.time_ts, xCorrelationId)
  }
  if (item.post_time?.time_ts) {
    item.post_time.time_ts = decryptNum(item.post_time.time_ts, xCorrelationId)
  }
}
